import { memo, useState, useCallback } from 'react';
import styled from 'styled-components';
import { useNavigate, useLocation } from 'react-router';

import { APP_ROUTES } from '@navigation/types';
import { theme } from 'theme';
import { getRedirectPath, clearRedirectPath } from '@utils/redirect';
import AuthTitle from '@components/auth/AuthTitle';
import AuthLayout from '@components/layouts/AuthLayout';
import { DefaultText } from '@components/text';
import ProfileImage from '@components/profileImage';
import { StyledButton } from '@components/form/styled';

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  gap: 16px;
`;

const NextButton = styled(StyledButton)`
  width: 100%;
`;

const OnboardingAvatarGeneration = () => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const navigate = useNavigate();
  const location = useLocation();

  const handleProcessing = useCallback((isProcessing: boolean) => {
    setIsLoading(isProcessing);
  }, []);

  const onGoNext = useCallback(() => {
    const from =
      (location.state as { from?: string })?.from || getRedirectPath();

    clearRedirectPath();
    navigate(from || APP_ROUTES.HOME, { replace: true });
  }, [navigate, location.state]);

  return (
    <AuthLayout>
      <Content>
        <AuthTitle title='Let’s create your avatar' />

        <DefaultText>
          You can also do it later in your profile settings
        </DefaultText>

        <ProfileImage handleProcessing={handleProcessing} />

        <NextButton
          onClick={onGoNext}
          disabled={isLoading}
          isLoading={isLoading}
          type='submit'
          textStyle={{ fontSize: theme.fonts.fontSize.xl }}
        >
          Next
        </NextButton>
      </Content>
    </AuthLayout>
  );
};

export default memo(OnboardingAvatarGeneration);
